export default __webpack_public_path__ + "static/media/p_wdt_c_0_1.b0ae162c.mp3";